import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useMMDispatchActions, useMMSelector } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getTierStreamId } from '../helpers';
import { getTiers } from '../selectors';
import { fetchMoreTiers } from '../actions';
const mapStateToProps = (state)=>{
    const streamId = getTierStreamId();
    const tiers = getTiers(state);
    return {
        tiers,
        isFetchingTiers: selectors.isFetching(state, streamId),
        isTierStreamInitialized: selectors.isInitialized(state, streamId),
        hasMoreTiers: selectors.hasMore(state, streamId)
    };
};
export const useTiers = ()=>_object_spread({}, useMMSelector(mapStateToProps), useMMDispatchActions({
        fetchMoreTiers
    }));

//# sourceMappingURL=withTiers.js.map